var styles = {
  "Checkbox": "pb-Checkbox__Checkbox",
  "input": "pb-Checkbox__input",
  "inputContainer": "pb-Checkbox__inputContainer",
  "label": "pb-Checkbox__label",
  "inputMask": "pb-Checkbox__inputMask",
  "color": "pb-Checkbox__color",
  "inputMask--checked": "pb-Checkbox__inputMask--checked",
  "icon": "pb-Checkbox__icon",
  "inputMask--invalid": "pb-Checkbox__inputMask--invalid"
};
export default styles;